@if (name) {
  <div class="file-modal">
    <div class="d-flex align-items-center justify-content-between p-3">
      <h6 class="card-title text-dark bg-white">{{ name }}</h6>
      <i class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </i>
    </div>
    <div
      class="card-text text-dark text-center"
      [ngClass]="{ 'image-height': name.search('.jpg') > 0 }"
    >
      @if (name.search('.jpg') > 0) {
        <img
          [src]="file"
          [ngClass]="{ 'zoom-in': zoomIn, 'zoom-out': !zoomIn }"
          (click)="zoom()"
        />
      } @else {
        @if (name.search('.pdf') > 0) {
          <pdf-viewer class="h-100" [src]="file" [render-text]="true">
          </pdf-viewer>
        }
      }
    </div>
  </div>
}
